import { useEffect } from 'react'
import { trackExperimentViewed } from '@mc/track-event'
import { CORE_MEMBERSHIP_LANGUAGE_CLEANUP_FLAG_NAME } from '../constants'

export const useLanguageCleanupEV = (track: boolean = true) => {
  useEffect(() => {
    if (track) {
      trackExperimentViewed(CORE_MEMBERSHIP_LANGUAGE_CLEANUP_FLAG_NAME)
    }
  }, [track])
}
